import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import { mapGetters } from 'vuex';
import { logout as _logout } from '@/services/user';
import event from "@/event";
export default {
  name: 'HeaderAvatar',
  i18n: require('./i18n-header'),
  computed: _objectSpread({}, mapGetters('account', ['user'])),
  mounted: function mounted() {
    var _this = this;
    event.listener("e_reloadusername", function (e) {
      _this.user.compellation = e;
    });
  },
  methods: {
    editPwd: function editPwd() {
      this.$emit("callEditPwd");
    },
    logout: function logout() {
      _logout();
      localStorage.clear();
      this.$router.push('/login');
    }
  }
};